import { logger } from '@meshwatch/logging';
import { Pool, PoolConfig, QueryConfig, QueryResult } from 'pg';

import TimeUtils from '../../util/time';
import { DatabaseException } from '../rest';

const DEFAULT_POOL_CONFIG: PoolConfig = {
  user: process.env.POSTGRES_USER || 'postgres',
  password: process.env.POSTGRES_PASSWORD || 'postgres',
  port: parseInt(process.env.POSTGRES_PORT || '5431', 10),
  database: process.env.POSTGRES_DATABASE_NAME || 'postgres',
  host: process.env.POSTGRES_HOST || 'localhost',
};

class PostgresClient {
  private readonly pool: Pool;

  public constructor(pool: Pool) {
    this.pool = pool;
  }

  private isConfig = (param: QueryConfig | string): param is QueryConfig => {
    return (param as QueryConfig).text !== undefined;
  };

  public close = (): Promise<void> => {
    return this.pool.end();
  };

  public query = (config: QueryConfig | string): Promise<QueryResult> => {
    const t0 = TimeUtils.startTimer();

    if ('development' === process.env.NODE_ENV) {
      logger.debug('------------------------------------------');
      const text = this.isConfig(config) ? config.text : config;
      logger.debug(`${'[Postgres]: Executing query: '.padEnd(25)} [${text}]`);
      if (this.isConfig(config) && config.values) {
        logger.debug(`${'[Postgres]: Substitution values: '.padEnd(25)} [${config.values}]`);
      }
    }

    return this.pool
      .query(config)
      .then(resp => {
        if ('development' === process.env.NODE_ENV) {
          logger.debug(
            `${'[Postgres]: Query took: '.padEnd(25)} [${TimeUtils.startTimer() - t0}ms]`
          );
          logger.debug('------------------------------------------');
        }
        return resp;
      })
      .catch((err: Error) => {
        const errorMessage = `[Postgres]: Something went wrong while executing query`;
        logger.error(errorMessage, err);
        throw new DatabaseException(`${errorMessage}: ${err.message}`);
      });
  };
}

export const DEFAULT_POSTGRES_CLIENT = new PostgresClient(new Pool(DEFAULT_POOL_CONFIG));

export default PostgresClient;
